import { Component, Input } from '@angular/core';
import { GlobalAppData } from '../models/global-app-data';
import { Constants } from '../constants/constants';

@Component({
  selector: 'app-accepted-payment-types',
  templateUrl: './accepted-payment-types.component.html',
  styleUrls: ['./accepted-payment-types.component.css'],
  standalone: false
})
export class AcceptedPaymentTypesComponent {
  @Input() paypalEnabled: boolean;
  @Input() alipayEnabled: boolean;
  @Input('disabledPaymentMethodNames') disabledPaymentMethodNames = [];
  
  // Global OSC codes
  oscCodes: Array<any> = Constants.OSC_SYSTEM_CODES;
  @Input() spcOscCode: String;

  constructor(public gd: GlobalAppData) {
  }

  showCreditcardType(val: string): boolean {
    return this.disabledPaymentMethodNames.indexOf(val) === -1;
  }
}

